class TemplateSaveController {
  /* @ngInject */
  constructor($uibModalInstance, $http, caseId, caseConfig, user) {
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.caseId = caseId;
    this.caseConfig = caseConfig;
    this.user = user;
  }

  $onInit() {

  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;
    this.$http.post('/clientCategory', {
      name: this.name,
      config: this.caseConfig,
      user: this.user,
    })
      .then(() => {
        this.submitting = false;
        this.$uibModalInstance.close();
      })
      .catch(() => (this.submitting = false));
  }
}

export default TemplateSaveController;



// WEBPACK FOOTER //
// ./client/components/template-save/template-save-modal.js